<template>
    <div>
        <base-stueck
                name="Drache"
                path-name="Drache"
                title="Der Drache"
                subtitle="Ein satirisches Märchen von Jewgeni Schwarz"
                :hasPlakat="false"
                :bilder-anzahl="6"
        >
            <template #beschreibung>
              In einer Welt, in der ein Drache seit 400 Jahren über eine Stadt herrscht,
              scheint der Kampf gegen das Böse längst verloren. Doch als der tapfere Lancelot
              auftaucht, erwacht die Hoffnung auf Freiheit. Wird er es schaffen,
              den Drachen zu besiegen und die Stadt zu befreien?
              Oder wird die Tyrannei weitergehen – mit einem neuen Herrscher?
              <br><br>
              Dieses packende und zugleich tiefsinnige Stück von
              Jewgeni Schwarz begeistert mit schwarzem Humor, überraschenden Wendungen
              und einer zeitlosen Botschaft über Macht, Mut und Manipulation.
              <br><br>
              Erleben Sie ein modernes Märchen, das zum Nachdenken anregt und zugleich unterhält!
            </template>
        </base-stueck>
    </div>
</template>

<script>

    import BaseStueck from "../../components/waswar/BaseStueck";

    export default {
        name: "Drache",
        components: {BaseStueck},
        metaInfo: {
            title: "Der Drache",
            meta: [
                {name: 'description', content: 'Details zu unserer Produktion: Der Drache'}
            ]
        },
    }
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  font-size: small;
  padding: 8px;
}

tr:first-child {
  background-color: #eee;
}
</style>